export default __webpack_public_path__ + "static/media/category.289e8f06.svg";